import { Settings2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type DefaultsSectionProps = {
  onOpenTags: () => void;
};

export function DefaultsSection({ onOpenTags }: DefaultsSectionProps) {
  return (
    <Card className="rounded-lg py-0">
      <CardHeader className="border-b px-4 py-4">
        <CardTitle className="flex items-center gap-2 text-base">
          <Settings2 className="h-4 w-4" />
          Listing defaults
        </CardTitle>
        <p className="text-sm text-muted-foreground">
          Defaults are planned for future listing setup rules.
        </p>
      </CardHeader>
      <CardContent className="px-4 py-4">
        <div className="rounded-lg border border-dashed bg-muted/20 p-4">
          <p className="text-sm font-medium">
            No listing defaults are editable yet.
          </p>
          <p className="mt-1 text-sm text-muted-foreground">
            Start with custom property tags to improve how agents classify
            listings today.
          </p>
          <Button className="mt-4" variant="outline" onClick={onOpenTags}>
            Open property tags
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
